import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react';
import { ThemeContext, type Theme } from './ThemeContext';

const THEME_KEY = 'grhamoy.theme';
const SIDEBAR_KEY = 'grhamoy.sidebarCollapsed';

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>(() => {
    const saved =
      (typeof localStorage !== 'undefined' && localStorage.getItem(THEME_KEY)) as Theme | null;
    return saved === 'dark' ? 'dark' : 'light';
  });
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(() => {
    return typeof localStorage !== 'undefined' && localStorage.getItem(SIDEBAR_KEY) === '1';
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem(SIDEBAR_KEY, sidebarCollapsed ? '1' : '0');
  }, [sidebarCollapsed]);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);
  const toggleSidebar = useCallback(() => setSidebarCollapsed((c) => !c), []);

  const value = useMemo(
    () => ({ theme, toggle, sidebarCollapsed, toggleSidebar }),
    [theme, toggle, sidebarCollapsed, toggleSidebar],
  );

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}
